module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c5c1f3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/footer.vue
// module id = 1211
// module chunks = 21